import { useCallback, useRef, useState } from 'react';

import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// A note for the patient that they have not opened yet. Pressing the card
// opens the note in place and records that it was seen, so the card stays
// for this visit and is gone on the next one. It is recorded once, however
// often the card is opened and closed; when recording it failed, it is not
// taken as recorded, and the next opening tries again.
export function NewNote({ note, onOpen }) {
  const { text, language } = useLanguage();
  const [ open, setOpen ] = useState(false);
  const seen = useRef(false);
  const { id, body, clinician, sessionStartsAt } = note;

  const onClick = useCallback(function() {
    setOpen(function(was) {
      return was === false;
    });

    if (seen.current === false) {
      seen.current = true;
      onOpen(id).catch(function() {
        seen.current = false;
      });
    }
  }, [ id, onOpen ]);

  const session = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'long' }).format(new Date(sessionStartsAt));

  let content = null;

  if (open === true) {
    content = <p id='new-note-body' className={ styles.body }>{ body }</p>;
  }

  return (
    <section className={ styles.card }>
      <button className={ styles.head } type='button' aria-expanded={ open } aria-controls='new-note-body' onClick={ onClick }>
        <span className={ styles.dot } aria-hidden='true'></span>

        <span className={ styles.lines }>
          <span className={ styles.title }>{ text.newNoteFrom.replace('{name}', clinician) }</span>
          <span className={ styles.session }>{ text.fromSession.replace('{date}', session) }</span>
        </span>
      </button>

      { content }
    </section>
  );
}
